import { TranslationsData } from 'chaika-frontend-types/frontend-cms';
import { Nullable } from 'chaika-common-types';

import { parseStringToLocale } from '@utils/stringToLocaleParser';
import { OptionType } from '@components/Select';

interface Props {
    selectedIds: string[];
    onChange(item: Partial<TranslationsData>): void;
}

interface Data {
    onItemChange(params: Nullable<OptionType>): void;
}

export function useHandlers({ onChange, selectedIds }: Props): Data {
    function onItemChange(params: Nullable<OptionType>): void {
        if (!selectedIds.includes(params?.value?.toString() ?? '')) {
            onChange({
                locale: params?.value ? parseStringToLocale(params.value.toString()) : undefined,
            });
        }
    }

    return {
        onItemChange,
    };
}
